const translations = {
  it: {
    // HeroSection
    heroTitle: "Fotografia Etica? Una scelta sicura",
    heroParagraph:
      "La foto etica è una fotografia realizzata nel rispetto della persona ritratta, tutelandone dignità, consenso e privacy.\nValorizzando l’individuo oltre all’immagine finale.",

    //Features

    ctaTitle: "COSA TI PROPONGO?",
    featuresCard1Title: "Etica",
    featuresCard1TextPart1: "Utilizzo una ",
    featuresCard1TextPdf: "LIBERATORIA",
    featuresCard1TextPart2: " che ti tutela in tutto prima, e dopo lo scatto.",
    featuresCard2Title: "Originalità",
    featuresCard2Text: "Ogni progetto è unico e curato nei minimi dettagli.",
    featuresCard3Title: "Sostegno",
    featuresCard3Text:
      "Organizzeremo lo shooting perfetto per te, e ti guiderò mentre scattiamo.",
    featuresCard4Title: "Sensibilità",
    featuresCard4Text:
      "Molte persone non si sentono a loro agio davanti all'obiettivo. Prova con me e vedrai la differenza.",
    featuresButton: "Non ti fidi,ecco cosa dicono di me!",

    // Navbar
    navDicono: "Dicono di me",
    navServizi: "Servizi",
    navPortfolio: "Portfolio",
    navAbout: "About me",
    navFAQ: "FAQ",
    navContattami: "Contattami",
    navPulsante: "SCATTIAMO ASSIEME",

    // AboutSection
    aboutTitle: "Servizi standard e Personalizzati.",
    aboutList: [
      "✔ Book fotografici",
      "✔ Shooting in studio con luci artificiali",
      "✔ Shooting in esterna",
      "✔ Foto per cataloghi e brochure",
      "✔ Shooting di coppia in studio o in Esterna",
      "✔ Shooting premaman",
      "✔ Organizzazione model sharing ed Eventi fotografici",
      "✔ Multishooting",
      "✔ Shooting first experience",
    ],
    aboutButton: "CONTATTAMI PER SHOOTING PERSONALIZZATI",

    // Services
    servicesTitle: "About Me",
    servicesText:
      "Mi chiamo Simone Terzi (alias Thirdiography), nato nel 1992 in Italia e attualmente residente a Kabelvag nelle Isole Lofoten, in Norvegia. La mia passione per la fotografia nasce dalla curiosità e dal desiderio di immortalare il mondo che mi circonda. È così che mi sono avvicinato alla fotografia di ritratto. Con il tempo, però, mi sono reso conto che mi mancava una dimensione più umana ed empatica nella fotografia. Da lì è nato il desiderio di esplorare un diverso approccio alla ritrattistica: uno che non si concentrasse soltanto sul risultato finale, ma anche sulla persona dietro l'immagine.",
    servicesImgAlt: "Service 2",

    // FAQ Section
    faqTitle: "DOMANDE FREQUENTI",
    faqQ1: "Cos'è la fotografia etica?",
    faqA1:
      "È una fotografia che rispetta dignità, consenso e privacy della persona ritratta.",
    faqQ2: "Perché è importante chiedere il consenso?",
    faqA2:
      "Il consenso garantisce che la persona si senta rispettata e tutelata.",
    faqQ3: "La fotografia etica limita la creatività?",
    faqA3: "Al contrario, stimola a creare immagini autentiche e rispettose.",
    faqQ4: "Posso revocare il consenso dopo lo shooting?",
    faqA4:
      "Sì, puoi sempre rivedere e modificare gli accordi sulla pubblicazione.",
    faqQ5: "Chi può beneficiare della fotografia etica?",
    faqA5:
      "Chiunque desideri essere fotografato in un ambiente sicuro e rispettoso.",
    faqQ6: "Come vengono gestite le mie foto?",
    faqA6:
      "Le immagini vengono archiviate e condivise solo con la tua autorizzazione.",
    faqQ7: "Cosa succede se non mi sento a mio agio?",
    faqA7: "Si interrompe lo shooting e si trovano soluzioni insieme.",
    faqQ8: "Perché scegliere un fotografo etico?",
    faqA8: "Per avere ricordi autentici senza compromettere i tuoi diritti.",

    // ContactDirect / ContactFAQ
    contactTitle: "Hai domande?",
    contactSubtitle:
      "Descrivimi il tuo progetto fotografico, lo faremo assieme!",
    contactNamePlaceholder: "Il tuo Nome",
    contactEmailPlaceholder: "La tua E-mail",
    contactPhonePlaceholder: "Il tuo numero di Telefono",
    contactMessagePlaceholder: "Il tuo progetto/domande",
    contactPrivacy: "Accetto la privacy",
    contactButton: "SCATTIAMO!",
    contactFAQButton: "COSA ASPETTI! SCATTIAMO!",

    // Italiano
    contactWarning: "Per favore, compila tutti i campi obbligatori.",
    contactInvalidEmail: "Per favore, inserisci un'email valida.",
    contactPrivacyRequired: "È necessario accettare la privacy.",
    contactSuccess: "Messaggio inviato con successo!",
    contactError: "Si è verificato un errore. Riprova più tardi.",

    // CommentCarousel
    commentTitle: "Dicono di me",
    comments: [
      {
        text: "Grazie a quell'esperienza per me impensabile ho potuto iniziare una serie di sfide personali ... Hai saputo rendere tutto indimenticabile e divertente ma allo stesso tempo professionale, sei una persona e un fotografo veramente fantastico.",
        author: "Giulia",
      },
      {
        text: "Con te mi sono sempre trovata benissimo e super a mio agio, perfino a scattare al mare davanti a tutti non mi sono vergognata, anche mentre mi tremava il naso.",
        author: "Aylin",
      },
      {
        text: "Scattare insieme è curativo, ti riempie di emozioni positive, risate, leggerezza e comprensione. E dopo, la ciliegina sulla torta, delle foto stupende. Simone è in grado di farti amare te stessa, con tutte le tue imperfezioni, perché attraverso il suo obbiettivo crea magia.",
        author: "Virginia",
      },
      {
        text: "Mi sono rimessa in gioco con te dopo anni di stop dal mondo della fotografia, dopo aver avuto due figli e in un momento difficile della mia vita ... E tu sei stato in grado fin da subito di farmi sentire a mio agio, di farmi sorridere e di farmi rivedere bella... nella semplicità dei tuoi scatti sei in grado di tradurre emozioni, e stati d'animo ...nelle foto in esterna, dai il meglio di te creando un tutt'uno tra la natura e la 'modella'.",
        author: "Federica",
      },
      {
        text: "Io mi sono trovata molto bene, fatta sentire subito a mio agio, oltre che molto professionale mi sono anche divertita molto, una gran persona.",
        author: "Erika",
      },
      {
        text: "Simone è stata la mia medicina nonostante io non fossi una modella. Con le sue foto è riuscito a farmi superare un momento particolare della mia vita, facendomi tirare fuori una bella dose di coraggio ma soprattutto facendomi ritrovare l’autostima che avevo perso. Ma quello che caratterizza Simone è che le sue foto sono pura emozione: tutti sono capaci di scattare foto, ma pochi sanno ricavare da uno scatto l’essenza del soggetto. Simone ti sa mettere a tuo agio, è l’amico che tutti dovrebbero avere. Ogni scatto, quando lo guardo, mi fa rivivere le emozioni di quel momento.",
        author: "Desirè",
      },
      {
        text: "Ho posato in più occasioni con Simone, sia all’aperto che in studio, per shooting di diverso genere, e mi sono sempre trovata super super bene. Molto professionale, educato e al contempo simpaticissimo. Nonostante i miei “nostri” scatti preferiti siano sempre quelli più spontanei (dove ogni espressione è il frutto più sincero delle conversazioni che stiamo facendo), se si preferiscono scatti “più impostati” o magari si è alla prima esperienza Simone sa consigliare pose ed espressioni in modo da aiutare e/o mettere tutti a proprio agio.",
        author: "Marta",
      },
      {
        text: "Con Simone è stato il mio primo shooting! Io colto da panico ed imbarazzo e lui, complice la nostra amicizia, ha saputo mettermi a mio agio!! Sento di fargli i complimenti anche per come la sua passione per la fotografia.",
        author: "Patrick",
      },
      {
        text: "Simone è bravissimo oltre a metterti a tuo agio ad ogni shooting ( cosa non scontata) fa anche delle foto pazzesche. La sua miglior qualità è l’empatia perché riesce subito a capire la persona che ha di fronte e con la sua simpatia tra uno scatto e l’altro riesce a catturare sempre i soggetti in modo autentico, ottenendo così foto naturali e professionali",
        author: "Sara",
      },
      {
        text: "Simone è un fotografo molto professionale, gentile ed organizzato allo stesso tempo è una persona simpatica, comprensiva e rispettosa dei limiti di ogni persona. Non importa se sei alle prime armi, lui riesce a metterti a tuo agio e a guidarti nella realizzazione del progetto concordato. Scattare con Simo è sempre un piacere ed una garanzia.",
        author: "Giulia",
      },
    ],

    // Footer
    footerSlogan: "Brilla sempre, non ti spegnere mai",
    footerLinksTitle: "Link Utili",
    footerContactTitle: "Contatti",
    footerLinks: ["Homepage", "Dicono di me", "Contact"],
    footerPhone: "Telefono: +39 347 5177824",
    footerEmail: "Email: thirdiograpy@gmail.com",
    footerCopyright: "© 2026 Thirdiograpy Design. Tutti i Diritti Riservati.",

    // Privacy (inserito qui per facilità di accesso)

    privacyTitle: "Informativa Privacy",
    privacyBody: `**Titolare del trattamento:**\nSimone Terzi – Thirdiograpy\nEmail: thirdiograpy@gmail.com\n\n**Dati raccolti:**\n- Dati forniti direttamente dall’utente tramite form: nome, email, numero di telefono, messaggio.\n- Dati di navigazione: indirizzo IP, browser, log di accesso, cookie tecnici.\n\n**Finalità del trattamento:**\n1. Rispondere a richieste di informazioni o preventivi.\n2. Fornire servizi fotografici richiesti.\n3. Inviare comunicazioni informative o promozionali, solo se l’utente ha espresso consenso.\n4. Adempiere obblighi legali e fiscali.\n\n**Base giuridica:**\n- Consenso espresso dell’interessato.\n- Esecuzione di un contratto o misure precontrattuali.\n- Obblighi di legge.\n\n**Modalità di trattamento:**\nI dati sono trattati con strumenti elettronici e manuali in modo sicuro, limitando l’accesso solo al personale autorizzato.\n\n**Conservazione dei dati:**\n- I dati forniti tramite il form vengono conservati per il tempo necessario a gestire la richiesta.\n- Eventuali dati per finalità promozionali vengono conservati fino a revoca del consenso.\n\n**Diritti dell’interessato:**\nHai il diritto di:\n- Accedere ai tuoi dati personali.\n- Chiedere la rettifica o la cancellazione.\n- Limitare o opporti al trattamento.\n- Richiedere la portabilità dei dati.\n- Revocare il consenso in qualsiasi momento senza pregiudicare la liceità del trattamento precedente.\n\n**Modalità di esercizio dei diritti:**\nPuoi inviare richiesta tramite email a: thirdiograpy@gmail.com\n\n**Condivisione dei dati:**\nI dati non saranno ceduti a terzi senza consenso, salvo obblighi di legge o fornitori di servizi strettamente necessari (es. provider email).\n\n**Cookie:**\nIl sito utilizza solo cookie tecnici e analytics anonimi per migliorare la navigazione. Non vengono utilizzati cookie di profilazione senza consenso.\n\n**Autorità di controllo:**\nPer eventuali reclami puoi rivolgerti all’Autorità Garante per la protezione dei dati personali (Italia) o l’equivalente locale.`,

    contactPrivacyRead: "leggi",
  },

  en: {
    // HeroSection
    heroTitle: "Ethical Photography? A Safe Choice",
    heroParagraph:
      "An ethical photo is a photograph taken with respect for the person portrayed, safeguarding their dignity, consent and privacy, and valuing the individual beyond the final image.",

    //Features
    ctaTitle: "WHAT SHOULD I PROPOSE TO YOU?",
    featuresCard1Title: "Ethics",
    featuresCard1TextPart1: "I use a ",
    featuresCard1TextPdf: "WAIVER ",
    featuresCard1TextPart2:
      "that protects you completely before and after the shot.",
    featuresCard2Title: "Originality",
    featuresCard2Text: "Every project is unique and curated in every detail.",
    featuresCard3Title: "Support",
    featuresCard3Text:
      "We will organize the perfect shooting for you, and I will guide you while we shoot.",
    featuresCard4Title: "Sensitivity",
    featuresCard4Text:
      "Many people feel uncomfortable in front of the camera. Try with me and you will see the difference.",
    featuresButton: "Don't trust me? Here's what they say about me!",

    // Navbar
    navDicono: "Testimonials",
    navServizi: "Services",
    navPortfolio: "Portfolio",
    navAbout: "About me",
    navFAQ: "FAQ",
    navContattami: "Contact",
    navPulsante: "LET'S SHOOT TOGETHER",

    // AboutSection
    aboutTitle: "Standard and Custom Services.",
    aboutList: [
      "✔ Photo books",
      "✔ Studio shooting with artificial lights",
      "✔ Outdoor shooting",
      "✔ Photos for catalogs and brochures",
      "✔ Couple shooting in studio or outdoors",
      "✔ Maternity shooting",
      "✔ Organizing model sharing and photography events",
      "✔ Multishooting",
      "✔ First experience shooting",
    ],
    aboutButton: "CONTACT ME FOR CUSTOM SHOOTINGS",

    // Services
    servicesTitle: "About Me",
    servicesText:
      "My name is Simone Terzi (aka Thirdiography), born in 1992 in Italy and currently based in Kabelvåg, in the Lofoten Islands, Norway. My passion for photography stems from curiosity and a desire to capture the world around me. This is what first drew me to portrait photography. Over time, however, I realized that I was missing a more human and empathetic dimension in photography. This led me to explore a different approach to portraiture, which focuses not only on the final result, but also on the person behind the image.",
    servicesImgAlt: "Service 2",

    // FAQ Section
    faqTitle: "FREQUENTLY ASKED QUESTIONS",
    faqQ1: "What is ethical photography?",
    faqA1:
      "It is photography that respects dignity, consent, and privacy of the person portrayed.",
    faqQ2: "Why is asking for consent important?",
    faqA2: "Consent ensures that the person feels respected and protected.",
    faqQ3: "Does ethical photography limit creativity?",
    faqA3: "On the contrary, it encourages authentic and respectful images.",
    faqQ4: "Can I withdraw my consent after the shoot?",
    faqA4:
      "Yes, you can always review and change the agreements on publication.",
    faqQ5: "Who can benefit from ethical photography?",
    faqA5:
      "Anyone who wants to be photographed in a safe and respectful environment.",
    faqQ6: "How are my photos managed?",
    faqA6: "Images are stored and shared only with your authorization.",
    faqQ7: "What if I feel uncomfortable?",
    faqA7: "The shooting is paused and we find solutions together.",
    faqQ8: "Why choose an ethical photographer?",
    faqA8: "To have authentic memories without compromising your rights.",

    // ContactDirect / ContactFAQ
    contactTitle: "Any questions?",
    contactSubtitle:
      "Describe your photography project, we will do it together!",
    contactNamePlaceholder: "Your Name",
    contactEmailPlaceholder: "Your Email",
    contactPhonePlaceholder: "Your Phone Number",
    contactMessagePlaceholder: "Your project/questions",
    contactPrivacy: "I accept the privacy policy",
    contactButton: "LET'S SHOOT!",
    contactFAQButton: "WHAT ARE YOU WAITING FOR! LET'S SHOOT!",

    // Inglese
    contactWarning: "Please fill in all required fields.",
    contactInvalidEmail: "Please enter a valid email address.",
    contactPrivacyRequired: "You must accept the privacy policy.",
    contactSuccess: "Message sent successfully!",
    contactError: "An error occurred. Please try again later.",

    // CommentCarousel
    commentTitle: "Testimonials",
    comments: [
      {
        text: "Thanks to that experience, which was unthinkable for me, I was able to start a series of personal challenges ... You made everything unforgettable and fun but at the same time professional, you are a truly fantastic person and photographer.",
        author: "Giulia",
      },
      {
        text: "With you I have always felt great and at ease, even shooting at the beach in front of everyone I was not embarrassed, even while my nose was trembling.",
        author: "Aylin",
      },
      {
        text: "Shooting together is therapeutic, it fills you with positive emotions, laughter, lightness, and understanding. And afterwards, the cherry on top, stunning photos. Simone can make you love yourself, with all your imperfections, because through his lens he creates magic.",
        author: "Virginia",
      },
      {
        text: "I got back into action with you after years off photography, after having two children and during a difficult time in my life ... And you were able from the start to make me feel comfortable, smile, and see myself beautiful again ... in the simplicity of your shots you translate emotions and moods ... outdoors, you give your best creating a unity between nature and the 'model'.",
        author: "Federica",
      },
      {
        text: "I felt very comfortable, immediately at ease, very professional and I also had a lot of fun, a great person.",
        author: "Erika",
      },
      {
        text: "Simone was my medicine even though I wasn't a model. With his photos he helped me overcome a particular moment in my life, bringing out courage and self-esteem I had lost. What characterizes Simone is that his photos are pure emotion: everyone can take pictures, but few can capture the essence of the subject. Simone knows how to make you feel comfortable, he is the friend everyone should have. Every shot brings back the emotions of that moment.",
        author: "Desirè",
      },
      {
        text: "I have posed several times with Simone, both outdoors and in studio, for different types of shootings, and I always felt super comfortable. Very professional, polite, and at the same time very friendly. Even if our “favorite” shots are always the most spontaneous (where every expression is the sincerest result of our conversations), if you prefer “posed” shots or it’s your first experience, Simone knows how to guide you to help everyone feel at ease.",
        author: "Marta",
      },
      {
        text: "It was my first shooting with Simone! I was panicked and embarrassed and he, thanks to our friendship, made me feel comfortable!! I also want to compliment him for his passion for photography.",
        author: "Patrick",
      },
      {
        text: "Simone is excellent, besides making you comfortable at every shooting (not easy), he takes amazing photos. His best quality is empathy because he immediately understands the person in front of him and with his friendliness he always captures subjects authentically, obtaining natural and professional photos.",
        author: "Sara",
      },
      {
        text: "Simone is a very professional photographer, kind and organized, at the same time he is friendly, understanding, and respectful of everyone’s limits. Even if you are a beginner, he manages to make you feel comfortable and guides you in the realization of the project. Shooting with Simo is always a pleasure and a guarantee.",
        author: "Giulia",
      },
    ],

    // Footer
    footerSlogan: "Always shine, never turn off",
    footerLinksTitle: "Useful Links",
    footerContactTitle: "Contact",
    footerLinks: ["Homepage", "Testimonials", "Contact"],
    footerPhone: "Phone: +39 347 5177824",
    footerEmail: "Email: thirdiograpy@gmail.com",
    footerCopyright: "© 2026 Thirdiograpy Design. All rights reserved.",

    // Privacy (inserito qui per facilità di accesso)
    privacyTitle: "Privacy Policy",
    privacyBody: `**Data Controller:**\nSimone Terzi – Thirdiograpy\nEmail: thirdiograpy@gmail.com\n\n**Data Collected:**\n- Data provided directly by the user via the form: name, email, phone number, message.\n- Browsing data: IP address, browser, access logs, technical cookies.\n\n**Purpose of Processing:**\n1. Respond to requests for information or quotes.\n2. Provide requested photography services.\n3. Send informational or promotional communications, only if the user has given consent.\n4. Fulfill legal and fiscal obligations.\n\n**Legal Basis:**\n- Express consent of the data subject.\n- Execution of a contract or pre-contractual measures.\n- Legal obligations.\n\n**Processing Methods:**\nData is processed securely using electronic and manual tools, limiting access only to authorized personnel.\n\n**Data Retention:**\n- Form data is kept only as long as necessary to process the request.\n- Any data for promotional purposes is kept until consent is withdrawn.\n\n**Data Subject Rights:**\nYou have the right to:\n- Access your personal data.\n- Request correction or deletion.\n- Restrict or object to processing.\n- Request data portability.\n- Withdraw consent at any time without affecting the legality of prior processing.\n\n**How to Exercise Your Rights:**\nRequests can be sent by email to: thirdiograpy@gmail.com\n\n**Data Sharing:**\nData will not be shared with third parties without consent, except for legal obligations or strictly necessary service providers (e.g., email provider).\n\n**Cookies:**\nThe site uses only technical cookies and anonymous analytics to improve navigation. No profiling cookies are used without consent.\n\n**Supervisory Authority:**\nFor complaints, you can contact the Data Protection Authority (Italy) or the local equivalent.`,

    contactPrivacyRead: "read",
  },

  no: {
    // HeroSection
    heroTitle: "Etisk Fotografi? Et Sikkert Valg",
    heroParagraph:
      "Etisk fotografi er et fotografi tatt med respekt for personen som er avbildet, som ivaretar vedkommendes verdighet, samtykke og personvern, og verdsetter individet utover det endelige bildet.",

    //Features

    ctaTitle: "HVA SKAL JEG FORESLÅ FOR DEG?",
    featuresCard1Title: "Etikk",
    featuresCard1TextPart1: "Jeg bruker en ",
    featuresCard1TextPdf: "FRASKRIVELSE",
    featuresCard1TextPart2:
      " som beskytter deg fullt ut før og etter fotograferingen.",
    featuresCard2Title: "Originalitet",
    featuresCard2Text: "Hvert prosjekt er unikt og nøye gjennomført.",
    featuresCard3Title: "Støtte",
    featuresCard3Text:
      "Vi vil organisere den perfekte fotograferingen for deg, og jeg vil veilede deg mens vi fotograferer.",
    featuresCard4Title: "Følsomhet",
    featuresCard4Text:
      "Mange føler seg ukomfortable foran kameraet. Prøv med meg og du vil se forskjellen.",
    featuresButton: "Stoler du ikke på meg? Dette sier de om meg!",

    // Navbar
    navDicono: "Anmeldelser",
    navServizi: "Tjenester",
    navPortfolio: "Portefølje",
    navAbout: "Om meg",
    navFAQ: "FAQ",
    navContattami: "Kontakt",
    navPulsante: "LA OSS FOTOGRAFERE SAMMEN",

    // AboutSection
    aboutTitle: "Standard- og Tilpassede Tjenester.",
    aboutList: [
      "✔ Fotobøker",
      "✔ Studiofotografering med kunstig lys",
      "✔ Utendørs fotografering",
      "✔ Bilder til kataloger og brosjyrer",
      "✔ Parfotografering i studio eller utendørs",
      "✔ Gravidfotografering",
      "✔ Organisering av modellsharing og fotoarrangementer",
      "✔ Multishooting",
      "✔ Første erfaring fotografering",
    ],
    aboutButton: "KONTAKT MEG FOR TILPASSEDE FOTOGRAFERINGER",

    // Services
    servicesTitle: "Om Meg",
    servicesText:
      "Jeg heter Simone Terzi (også kjent som Thirdiography), født i 1992 i Italia, og er nå bosatt i Kabelvåg i Lofoten, Norge. Min lidenskap for fotografi springer ut av nysgjerrighet og et ønske om å forevige verden rundt meg. Det var slik jeg først ble tiltrukket av portrettfotografi. Med tiden innså jeg imidlertid at jeg savnet en mer menneskelig og empatisk dimensjon i fotografiet. Dette førte til at jeg ønsket å utforske en annen tilnærming til portrettfotografi, som ikke bare fokuserer på det endelige resultatet, men også på personen bak bildet.",
    servicesImgAlt: "Service 2",

    // FAQ Section
    faqTitle: "OFTE STILTE SPØRSMÅL",
    faqQ1: "Hva er etisk fotografering?",
    faqA1:
      "Det er fotografering som respekterer verdighet, samtykke og personvern til den avbildede personen.",
    faqQ2: "Hvorfor er det viktig å be om samtykke?",
    faqA2: "Samtykke sikrer at personen føler seg respektert og beskyttet.",
    faqQ3: "Begrenser etisk fotografering kreativiteten?",
    faqA3: "Tvert imot, det oppmuntrer til autentiske og respektfulle bilder.",
    faqQ4: "Kan jeg trekke tilbake samtykket etter fotograferingen?",
    faqA4:
      "Ja, du kan alltid endre eller trekke tilbake avtaler om publisering.",
    faqQ5: "Hvem kan ha nytte av etisk fotografering?",
    faqA5:
      "Alle som ønsker å bli fotografert i et trygt og respektfullt miljø.",
    faqQ6: "Hvordan blir bildene mine håndtert?",
    faqA6: "Bildene lagres og deles bare med din tillatelse.",
    faqQ7: "Hva skjer hvis jeg ikke føler meg komfortabel?",
    faqA7: "Fotograferingen stoppes, og vi finner løsninger sammen.",
    faqQ8: "Hvorfor velge en etisk fotograf?",
    faqA8: "For å få ekte minner uten å kompromittere dine rettigheter.",

    // ContactDirect / ContactFAQ
    contactTitle: "Har du spørsmål?",
    contactSubtitle: "Beskriv ditt fotoprosjekt, vi gjør det sammen!",
    contactNamePlaceholder: "Ditt navn",
    contactEmailPlaceholder: "Din e-post",
    contactPhonePlaceholder: "Ditt telefonnummer",
    contactMessagePlaceholder: "Ditt prosjekt/spørsmål",
    contactPrivacy: "Jeg godtar personvernreglene",
    contactButton: "LA OSS SKYTE!",
    contactFAQButton: "HVA VENTER DU PÅ! LA OSS FOTOGRAFERE!",

    // Norvegese
    contactWarning: "Vennligst fyll ut alle obligatoriske felt.",
    contactInvalidEmail: "Vennligst skriv inn en gyldig e-postadresse.",
    contactPrivacyRequired: "Du må godta personvernreglene.",
    contactSuccess: "Meldingen ble sendt!",
    contactError: "En feil oppstod. Vennligst prøv igjen senere.",

    // CommentCarousel
    commentTitle: "Anmeldelser",
    comments: [
      {
        text: "Takket være den opplevelsen, som var utenkelig for meg, kunne jeg starte en rekke personlige utfordringer ... Du gjorde alt uforglemmelig og morsomt, men samtidig profesjonelt. Du er en fantastisk person og fotograf.",
        author: "Giulia",
      },
      {
        text: "Med deg har jeg alltid følt meg veldig komfortabel, selv under fotografering på stranden foran alle ble jeg ikke flau, selv om nesen min skalv.",
        author: "Aylin",
      },
      {
        text: "Å fotografere sammen er terapeutisk, det fyller deg med positive følelser, latter, letthet og forståelse. Og etterpå, prikken over i-en, fantastiske bilder. Simone kan få deg til å elske deg selv, med alle dine ufullkommenheter, fordi han gjennom linsen sin skaper magi.",
        author: "Virginia",
      },
      {
        text: "Jeg startet igjen med deg etter flere års pause fra fotografering, etter å ha fått to barn og i en vanskelig periode av livet ... Og du klarte fra starten å få meg til å føle meg komfortabel, smile og se meg selv som vakker igjen ... i enkelheten i dine bilder oversetter du følelser og stemninger ... utendørs gir du ditt beste ved å skape en enhet mellom naturen og 'modellen'.",
        author: "Federica",
      },
      {
        text: "Jeg følte meg veldig bra, ble satt i komfort fra starten, veldig profesjonell og jeg hadde det også veldig gøy, en flott person.",
        author: "Erika",
      },
      {
        text: "Simone var min medisin selv om jeg ikke var en modell. Med bildene sine hjalp han meg å komme meg gjennom en spesiell tid i livet, og fikk meg til å finne mot og selvtillit jeg hadde mistet. Det som kjennetegner Simone er at bildene hans er ren følelse: alle kan ta bilder, men få kan fange essensen av motivet. Simone vet hvordan han skal få deg til å føle deg komfortabel, han er vennen alle burde ha. Hvert bilde bringer tilbake følelsene fra det øyeblikket.",
        author: "Desirè",
      },
      {
        text: "Jeg har posert flere ganger med Simone, både utendørs og i studio, for ulike typer fotograferinger, og jeg følte meg alltid superkomfortabel. Veldig profesjonell, høflig og samtidig veldig vennlig. Selv om våre 'favorittbilder' alltid er de mest spontane (hvor hvert uttrykk er det mest oppriktige resultatet av samtalene våre), hvis du foretrekker 'poserte' bilder eller det er din første erfaring, vet Simone hvordan han skal veilede deg for å hjelpe alle å føle seg komfortable.",
        author: "Marta",
      },
      {
        text: "Det var min første fotografering med Simone! Jeg var nervøs og flau, og han, takket være vennskapet vårt, fikk meg til å føle meg komfortabel!! Jeg vil også gi ham ros for hans lidenskap for fotografering.",
        author: "Patrick",
      },
      {
        text: "Simone er fantastisk, i tillegg til å få deg til å føle deg komfortabel under hver fotografering (ikke en selvfølge), tar han også utrolige bilder. Hans beste kvalitet er empati, fordi han umiddelbart forstår personen foran seg, og med sin vennlighet klarer han alltid å fange motivene på en autentisk måte, noe som gir naturlige og profesjonelle bilder.",
        author: "Sara",
      },
      {
        text: "Simone er en veldig profesjonell fotograf, snill og organisert, samtidig er han vennlig, forståelsesfull og respektfull overfor alles grenser. Selv om du er nybegynner, klarer han å få deg til å føle deg komfortabel og veileder deg i gjennomføringen av prosjektet. Å fotografere med Simo er alltid en glede og en garanti.",
        author: "Giulia",
      },
    ],

    // Footer
    footerSlogan: "Skin alltid, slukk aldri",
    footerLinksTitle: "Nyttige Lenker",
    footerContactTitle: "Kontakt",
    footerLinks: ["Hjemmeside", "Anmeldelser", "Kontakt"],
    footerPhone: "Telefon: +39 347 5177824",
    footerEmail: "E-post: thirdiograpy@gmail.com",
    footerCopyright: "© 2026 Thirdiograpy Design. Alle Rettigheter Reservert.",

    // Privacy (inserito qui per facilità di accesso)
    privacyTitle: "Personvernpolicy",
    privacyBody: `**Behandlingsansvarlig:**\nSimone Terzi – Thirdiograpy\nE-post: thirdiograpy@gmail.com\n\n**Innsamlede data:**\n- Data levert direkte av brukeren via skjemaet: navn, e-post, telefonnummer, melding.\n- Nettleserdata: IP-adresse, nettleser, tilgangslogger, tekniske cookies.\n\n**Formål med behandling:**\n1. Svare på forespørsler om informasjon eller tilbud.\n2. Levere forespurte fototjenester.\n3. Sende informasjons- eller kampanjekommunikasjon, kun hvis brukeren har gitt samtykke.\n4. Oppfylle juridiske og skattemessige forpliktelser.\n\n**Rettmessig grunnlag:**\n- Uttrykkelig samtykke fra den registrerte.\n- Utførelse av kontrakt eller pre-kontraktuelle tiltak.\n- Juridiske forpliktelser.\n\n**Behandlingsmåter:**\nData behandles sikkert med elektroniske og manuelle verktøy, med tilgang kun for autorisert personell.\n\n**Lagring av data:**\n- Skjemadata lagres kun så lenge det er nødvendig for å håndtere forespørselen.\n- Data for kampanjeformål lagres til samtykke trekkes tilbake.\n\n**Rettigheter for den registrerte:**\nDu har rett til å:\n- Få tilgang til dine personopplysninger.\n- Be om retting eller sletting.\n- Begrense eller protestere mot behandling.\n- Be om dataportabilitet.\n- Trekke tilbake samtykke når som helst uten å påvirke lovligheten av tidligere behandling.\n\n**Hvordan utøve rettigheter:**\nForespørsler kan sendes på e-post til: thirdiograpy@gmail.com\n\n**Deling av data:**\nData vil ikke bli delt med tredjeparter uten samtykke, bortsett fra ved lovpålagte krav eller nødvendige tjenesteleverandører (f.eks. e-postleverandør).\n\n**Cookies:**\nNettstedet bruker kun tekniske cookies og anonyme analysecookies for å forbedre navigasjonen. Ingen profileringcookies brukes uten samtykke.\n\n**Tilsynsmyndighet:**\nFor klager kan du kontakte Datatilsynet (Norge) eller lokal tilsvarende myndighet.`,

    contactPrivacyRead: "les",
  },
};

export default translations;
